// Regex from specification Semver in https://gitlab.com/ingenico-cloud-platform/icp/libraries/javascript/icp-toolkit-lib/-/blob/main/libs/api-sdk/api-sdk-device-management-private-v2/dm-PRIVATE-v2.yaml?ref_type=heads#L8043
// Related US https://ingenico-tech.atlassian.net/browse/MDMGT-6786;
export const versionRegex = /^(0|([1-9][0-9]*))\.(0|([1-9][0-9]*))\.(0|([1-9][0-9]*))$/u;
